import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Row, Col, Form, Input, DatePicker } from 'antd';
import moment from 'moment'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
const { RangePicker } = DatePicker;
const { TextArea } = Input;
@inject('reportStore','uiState')
@observer
class SearchForm extends Component {
  formRef = React.createRef();
  componentDidMount() {
    const { reportStore } = this.props
    reportStore.onChangeOrderList([])
  }
  handleSearch=()=>{
    const { reportStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        customerPos: fieldsValue.customerPos!==undefined&&fieldsValue.customerPos?.length>0?fieldsValue.customerPos?.split(","):[],
        shipTos: fieldsValue.shipTos!==undefined&&fieldsValue.shipTos?.length>0?fieldsValue.shipTos?.split(","):[],
        soldTos: fieldsValue.soldTos!==undefined&&fieldsValue.soldTos?.length>0?fieldsValue.soldTos?.split(","):[],
        goodsReceiptGlns: fieldsValue.goodsReceiptGlns!==undefined&&fieldsValue.goodsReceiptGlns?.length>0?fieldsValue.goodsReceiptGlns?.split(","):[],
        createDateBegin: !fieldsValue.billingDate[0] ?'':moment(fieldsValue.billingDate[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        createDateEnd: !fieldsValue.billingDate[1] ?'':moment(fieldsValue.billingDate[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      reportStore.onSearchOrderAction(params,1,PAGE_SIZE_DEFAULT)
    }).catch(err => {
    })
  }
  handleExport=()=>{
    const { uiState } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        customerPos: fieldsValue.customerPos!==undefined&&fieldsValue.customerPos?.length>0?fieldsValue.customerPos?.split(","):[],
        shipTos: fieldsValue.shipTos!==undefined&&fieldsValue.shipTos?.length>0?fieldsValue.shipTos?.split(","):[],
        soldTos: fieldsValue.soldTos!==undefined&&fieldsValue.soldTos?.length>0?fieldsValue.soldTos?.split(","):[],
        goodsReceiptGlns: fieldsValue.goodsReceiptGlns!==undefined&&fieldsValue.goodsReceiptGlns?.length>0?fieldsValue.goodsReceiptGlns?.split(","):[],
        createDateBegin: !fieldsValue.billingDate[0] ?'':moment(fieldsValue.billingDate[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        createDateEnd: !fieldsValue.billingDate[1] ?'':moment(fieldsValue.billingDate[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      uiState.onChangeFetchingExport('/open/api/v1/order/report/list/export', params, `Order_Report.xlsx`)
    }).catch(err => {
    })
  }
  render() {
    const checkMaxLength=(rule,value,callback)=>{
      if(value!==undefined&&value.length>1000){
        callback('The input content has exceeded 1000 characters！')
      }else {
        callback()
      }
    }
    return (
      <>
        <Form ref={this.formRef} initialValues={{}}>
          <Row>
            <Col span={8}>
              <Form.Item name='billingDate' label='Customer PO Date' labelCol={{span:9}} wrapperCol={{span: 15}} rules={[{ required:true,message: 'Please enter Customer PO Date.'}]}>
                <RangePicker
                  allowClear
                  format="YYYY-MM-DD"
                  key='RangePicker'
                  style={{width: '100%'}}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name='customerPos' label='Customer Po' labelCol={{span:9}} wrapperCol={{span: 15}}
                         rules={[{ message: 'Please enter Customer Po without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }, { validator: checkMaxLength}]}>
                <TextArea rows={1} placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name='soldTos' label='Sold to' labelCol={{span:9}} wrapperCol={{span: 15}}
                         rules={[{ message: 'Please enter Sold to without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) },{ validator: checkMaxLength}]}>
                <TextArea rows={1} placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={8} style={{marginTop:10}}>
              <Form.Item name='shipTos' label='Ship to' labelCol={{span:9}} wrapperCol={{span: 15}}
                         rules={[{ message: 'Please enter Ship to without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) },{ validator: checkMaxLength}]}>
                <TextArea rows={1} placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={8} style={{marginTop:10}}>
              <Form.Item name='goodsReceiptGlns' label='Goods Receipt GLN' labelCol={{span:9}} wrapperCol={{span: 15}}
                         rules={[{ message: 'Please enter Goods Receipt GLN without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) },{ validator: checkMaxLength}]}>
                <TextArea rows={1} placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={8} style={{textAlign: 'right', marginTop: 10}}>
              <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
              <Button onClick={this.handleExport} type='primary'>Export</Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

export default SearchForm;
